package com.devi3east.bashbuddy.features.designSystem.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.ui.graphics.Color

private val darkScheme = darkColorScheme(
    primary = Color(0xFF93B4E3),
    onPrimary = Color(0xFF001F3C),
    primaryContainer = Color(0xFF1E3A5F),
    onPrimaryContainer = Color(0xFFACC9F7),
    secondary = Color(0xFFFFD99B),
    onSecondary = Color(0xFF472A00),
    secondaryContainer = Color(0xFF6A3F00),
    onSecondaryContainer = Color(0xFFFFE2B3),
    tertiary = Color(0xFF9DDDB1),
    onTertiary = Color(0xFF003919),
    tertiaryContainer = Color(0xFF265C3A),
    onTertiaryContainer = Color(0xFFC7F1D7),
    error = Color(0xFFFFB4AB),
    onError = Color(0xFF690005),
    errorContainer = Color(0xFF93000A),
    onErrorContainer = Color(0xFFFFDAD6),
    background = Color(0xFF1A1A1A),
    onBackground = Color(0xFFEDE7E0),
    surface = Color(0xFF1F1F1F),
    onSurface = Color(0xFFF2EDEA),
    surfaceVariant = Color(0xFF52443C),
    onSurfaceVariant = Color(0xFFD7C2B8),
    outline = Color(0xFF9A9A9A),
    outlineVariant = Color(0xFF6B5C53),
    scrim = Color(0xFF000000),
    inverseSurface = Color(0xFFF0DFD7),
    inverseOnSurface = Color(0xFF312823),
    inversePrimary = Color(0xFF703911),
    surfaceDim = Color(0xFF19120D),
    surfaceBright = Color(0xFF413731),
    surfaceContainerLowest = Color(0xFF140D08),
    surfaceContainerLow = Color(0xFF221A15),
    surfaceContainer = Color(0xFF261E19),
    surfaceContainerHigh = Color(0xFF312823),
    surfaceContainerHighest = Color(0xFF3D332D),
)

@Immutable
data class ColorFamily(
    val color: Color,
    val onColor: Color,
    val colorContainer: Color,
    val onColorContainer: Color
)

val unspecified_scheme = ColorFamily(
    Color.Unspecified, Color.Unspecified, Color.Unspecified, Color.Unspecified
)

@Composable
fun BashBuddyTheme(
    content: @Composable () -> Unit
) {
    MaterialTheme(
        colorScheme = darkScheme,
        typography = AppTypography,
        content = content
    )
}